import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BrCard, BrButton } from '@govbr-ds/react-components';

export default function ExpertPersonasPage() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const personaIds = ['olivia', 'john_smith', 'dr_charles', 'dra_emily'];
    const personaEmojis: Record<string, string> = {
        olivia: '👵',
        john_smith: '👨',
        dr_charles: '👨‍⚖️',
        dra_emily: '👩‍⚖️'
    };

    return (
        <div className="container-lg py-4">
            <div className="row justify-content-center">
                <div className="col-12 col-lg-10 d-flex flex-column gap-4">
                    {/* Header */}
                    <div className="text-center mb-4">
                        <div className="w-16 h-16 bg-warning rounded-2xl mx-auto mb-3 d-flex align-items-center justify-content-center">
                            <span className="text-3xl">👥</span>
                        </div>
                        <h1 className="text-2xl font-bold text-gray-80">
                            {t('expert.personasPage.title')}
                        </h1>
                        <p className="text-gray-60 mt-2">
                            {t('expert.personasPage.description')}
                        </p>
                    </div>

                    {/* Personas Grid */}
                    <div className="d-grid gap-4" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))' }}>
                        {personaIds.map((personaId) => {
                            const needs = t(`expert.personasPage.personas.${personaId}.needs`, { returnObjects: true }) as string[];
                            return (
                                <BrCard
                                    key={personaId}
                                    className="p-3"
                                >
                                    {/* Header */}
                                    <div className="d-flex flex-column align-items-center text-center mb-4">
                                        <span className="text-4xl mb-2">{personaEmojis[personaId]}</span>
                                        <h3 className="font-bold text-lg text-gray-80 m-0">
                                            {t(`expert.personasPage.personas.${personaId}.name`)}
                                        </h3>
                                        <p className="text-base text-gray-60 m-0">
                                            {t(`expert.personasPage.personas.${personaId}.summary`)}
                                        </p>
                                    </div>

                                    {/* Info */}
                                    <div className="d-flex flex-column gap-2 text-base mb-4">
                                        <p><span className="font-medium">{t('expert.personasPage.age')}:</span> {t(`expert.personasPage.personas.${personaId}.age`)}</p>
                                        <p><span className="font-medium">{t('expert.personasPage.occupation')}:</span> {t(`expert.personasPage.personas.${personaId}.occupation`)}</p>
                                        <p><span className="font-medium">{t('expert.personasPage.education')}:</span> {t(`expert.personasPage.personas.${personaId}.education`)}</p>
                                        <p><span className="font-medium">{t('expert.personasPage.digitalProfile')}:</span> {t(`expert.personasPage.personas.${personaId}.techProfile`)}</p>
                                    </div>

                                    {/* Necessidades */}
                                    <div className="bg-gray-2 rounded-lg p-2 mb-3">
                                        <p className="font-semibold text-base text-gray-80 mb-2">{t('expert.personasPage.needs')}</p>
                                        <ul className="d-flex flex-column gap-1 list-none m-0 pl-0">
                                            {needs.map((need, idx) => (
                                                <li key={idx} className="text-base text-gray-80 d-flex align-items-start gap-2">
                                                    <span className="text-success">•</span>
                                                    {need}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    {/* Contexto */}
                                    <p className="text-gray-60 italic" style={{ fontSize: '18px', lineHeight: '1.5' }}>
                                        "{t(`expert.personasPage.personas.${personaId}.context`)}"
                                    </p>
                                </BrCard>
                            );
                        })}
                    </div>

                    {/* Aviso */}
                    <div className="p-4 bg-info rounded-lg" style={{ backgroundColor: 'rgba(19, 81, 180, 0.1)' }}>
                        <p className="text-sm text-gray-80 text-center">
                            <span className="font-semibold">💡 {t('expert.personasPage.remember')}</span> {t('expert.personasPage.rememberDesc')}
                        </p>
                    </div>

                    {/* Botão */}
                    <div>
                        <BrButton
                            primary
                            onClick={() => navigate('/especialista/avaliacao/0')}
                            className="w-full py-4 text-lg"
                            aria-label={t('expert.personasPage.startEvaluation')}
                        >
                            {t('expert.personasPage.startEvaluation')}
                        </BrButton>
                    </div>
                </div>
            </div>
        </div>
    );
}
